import { isResource } from '@medplum/core'
import type { Basic } from '@medplum/fhirtypes'
import { ExtendedResource } from '#src/ExtendedResource.ts'
import { isOfType } from '#src/utils.ts'

export class ExtendedBasic extends ExtendedResource<Basic> {
  static readonly RESOURCE_TYPE = 'Basic'

  static isInstance(value: unknown): value is Basic {
    return isResource(value) && isOfType(value, 'Basic')
  }

  get referenceString(): `Basic/${ExtendedBasic['id']}` {
    return `${ExtendedBasic.RESOURCE_TYPE}/${this.id}`
  }
}
